module.exports = __webpack_public_path__ + "static/media/current_contact.6621c5df.svg";